module.exports = __webpack_public_path__ + "static/img/concierge_logo.836b27b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/concierge_logo.png
// module id = mREU
// module chunks = 1